import React, { useState, createContext } from 'react'
// {
//   label: EXPRESSWAY_HEADER,
//   description: EXPRESSWAY_LISTITEM_DESCRIPTION,
//   icon: 'eway',
//   link: LOAD_EXPRESSWAY
// },
// {
//   label: WALLET_HEADER,
//   description: WALLET_LISTITEM_DESCRIPTION,
//   icon: 'wallet',
//   link: LOAD_WALLET
// },
// import { LOAD_EXPRESSWAY, LOAD_WALLET } from 'AccountsConstants/routes'
// EXPRESSWAY_HEADER,
// EXPRESSWAY_LISTITEM_DESCRIPTION,
// WALLET_HEADER,
// WALLET_LISTITEM_DESCRIPTION,
import {
  SUPPORT_HEADER,
  SUPPORT_LISTITEM_DESCRIPTION,
  SETTINGS_LISTITEM_DESCRIPTION,
  SETTINGS_HEADER
} from 'AccountsConstants/language/account'
import {
  SUPPORT_ICON,
  EXPRESSWAY_ICON,
} from 'AccountsConstants/app'

export const AccountContext = createContext({
  accountOpts: []
})

export const AccountState = ({ children }) => {
  const [accountOpts] = useState([
    {
      label: SETTINGS_HEADER,
      description: SETTINGS_LISTITEM_DESCRIPTION,
      icon: EXPRESSWAY_ICON,
      link: ''
    },
    {
      label: SUPPORT_HEADER,
      description: SUPPORT_LISTITEM_DESCRIPTION,
      icon: SUPPORT_ICON,
      link: ''
    }
  ])

  return (
    <AccountContext.Provider
      value={{
        accountOpts
      }}
    >
      {children}
    </AccountContext.Provider>
  )
}
